import { TextField } from "@mui/material";
import get from "lodash/get";
import { Controller } from "react-hook-form";

import { getFieldError } from "../utils";

import type { CustomFieldComponentProps } from "../types";

const TextFieldComponent = ({
  field,
  methods,
}: CustomFieldComponentProps<"text">): React.JSX.Element => {
  const {
    formState: { errors },
  } = methods;
  const { customProps, name, transform } = field;
  const errorMessage = get(errors, name)?.message;
  const error = getFieldError(errorMessage);

  return (
    <Controller
      name={field.name}
      control={methods.control}
      defaultValue={field.defaultValue || ""}
      render={({ field: controllerField }) => (
        <TextField
          {...controllerField}
          value={(controllerField.value as string) ?? ""}
          onChange={(e) => {
            let value = e.target.value;

            if (transform) {
              const transformedValue = transform(value);
              if (transformedValue === null || transformedValue === undefined) {
                // If transform returns null/undefined, do not update the value
                return;
              }
              value = transformedValue;
            }

            controllerField.onChange(value);

            if (field.onChange) {
              const syntheticEvent: React.ChangeEvent<
                HTMLInputElement | HTMLTextAreaElement
              > = {
                ...e,
                target: {
                  ...e.target,
                  name: controllerField.name,
                  value,
                },
              };
              field.onChange(syntheticEvent);
            }
          }}
          label={field.label}
          fullWidth
          error={Boolean(error)}
          helperText={error}
          disabled={field.disabled}
          className={field.className}
          style={field.style}
          sx={field.sx}
          rows={customProps?.multiline ? 4 : 1}
          {...customProps}
          required={field.required ?? customProps?.required}
        />
      )}
    />
  );
};

export default TextFieldComponent;
